import { ActivityLog } from "../../../models/ActivityLog"
import { FetchErrorInfo, StartFetchingAction, SuccessFetchingAction, ErrorFetchingAction, FetchRequestActions } from "../../../utils/request-actions-helpers/createRequestActions"
import { getActivitiesActionTypes } from "./actions"
import { GetActivitiesAdditionalData, ToggleActivityLogAdditionalData } from "./actions/activitiesAdditionalData"
import { TOGGLE_ACTIVITY_LOG } from "./actions/toggleActivityLog"

export interface ActivitiesData {
    data?: ActivityLog[]
    isFetching: boolean
    isUpdating: boolean
    show: boolean
    fetchError?: FetchErrorInfo
    updateError?: FetchErrorInfo
}

export interface DocIdToActivitites {
    [docId: string]: ActivitiesData | undefined
}

export interface ActivitiesState {
    data: DocIdToActivitites
}

export type ActivitiesAction = FetchRequestActions<any, GetActivitiesAdditionalData> | ToggleActivityLogAdditionalData

export const initialActivitiesState: ActivitiesState = {
    data: {}
}
const initialActivititesData: ActivitiesData = {
    isFetching: false,
    isUpdating: false,
    show: false,
}

export const activitiesReducer = (state: ActivitiesState = initialActivitiesState, action: ActivitiesAction): ActivitiesState => {
    switch (action.type) {
        case TOGGLE_ACTIVITY_LOG: {
            const toggleActivityLogAdditionalData = action as ToggleActivityLogAdditionalData
            if (!toggleActivityLogAdditionalData) {
                return state
            }
            const newData: DocIdToActivitites = {}
            const {docId, show} = toggleActivityLogAdditionalData;
            const activitiesData = state.data[docId] || initialActivititesData

            newData[docId] = {
                ...activitiesData,
                show,
            }
            return {
                data: {
                    ...state.data,
                    ...newData
                }
            }
        }
        case getActivitiesActionTypes.start: {
            const startGetActivitiesAction = action as StartFetchingAction<GetActivitiesAdditionalData>
            if (!startGetActivitiesAction.additionalData) {
                return state
            }
            const newData: DocIdToActivitites = {}
            const {docId} = startGetActivitiesAction.additionalData;
            const activitiesData = state.data[docId] || initialActivititesData

            newData[docId] = {
                ...activitiesData,
                isFetching: true,
            }
            return {
                data: {
                    ...state.data,
                    ...newData
                }
            }
        }
        case getActivitiesActionTypes.success: {
            const successGetActivitiesAction = action as SuccessFetchingAction<ActivityLog[], GetActivitiesAdditionalData>
            if (!successGetActivitiesAction.additionalData) {
                return state
            }
            
            const {docId} = successGetActivitiesAction.additionalData
            const newData: DocIdToActivitites = {}

            const activitiesData = state.data[docId] || initialActivititesData
            if (successGetActivitiesAction.result.length === 0) {
                    newData[docId] = {
                        ...activitiesData,
                        isFetching: false
                    }
            } else {
                newData[docId] = {
                    ...activitiesData,
                    isFetching: false,
                    data: successGetActivitiesAction.result
                }
            }

            return {
                data: {
                    ...state.data,
                    ...newData
                }
            }
        }
        case getActivitiesActionTypes.error: {
            const errorFetchingDocumentsAction = action as ErrorFetchingAction<GetActivitiesAdditionalData>
            if (!errorFetchingDocumentsAction.additionalData) {
                return state
            }
            const newData: DocIdToActivitites = {}
            const {docId} = errorFetchingDocumentsAction.additionalData;
            const activitiesData = state.data[docId] || initialActivititesData
            newData[docId] = {
                ...activitiesData,
                isFetching: false,
                fetchError: errorFetchingDocumentsAction.error
            }

            return {
                data: {
                    ...state.data,
                    ...newData
                }
            }
        }

        default:
            return state
    }
}